import { twMerge } from '@shared/themes';

type StaticPageHeaderProps = {
  title: string;
  lastUpdated?: string;
  id?: string;
  'data-testid'?: string;
};

/**
 * Page title block for static content pages.
 *
 * Renders the document heading, optional last-updated line, and the divider
 * that separates the header from the body. Use once at the top of a static
 * page; the default `id` is the back-to-top target.
 *
 * @param title - Page heading
 * @param lastUpdated - Optional revision line shown above the heading
 * @param id - Anchor id for back-to-top links; defaults to `top`
 */
function StaticPageHeader({ title, lastUpdated, id = 'top', 'data-testid': dataTestId = 'static-page-header' }: StaticPageHeaderProps) {
  return (
    <>
      <section id={id} data-testid={dataTestId}>
        {lastUpdated ? (
          <p className="paragraph-explanatory-strong" data-testid="static-page-last-updated">
            {lastUpdated}
          </p>
        ) : null}
        <h1 className={twMerge('display-m md:display-l', lastUpdated && 'mt-2')} data-testid="static-page-title">
          {title}
        </h1>
      </section>
      <hr className="mt-12 mb-10" aria-hidden="true" data-testid="static-page-header-divider" />
    </>
  );
}

export { StaticPageHeader, type StaticPageHeaderProps };
